import React from "react";
import { TableCell, TableRow, Chip, IconButton, Tooltip } from "@mui/material";
import { Edit, FileText } from "lucide-react";

const getStatusColor = (status) => {
  const s = status?.toLowerCase();
  switch (s) {
    case "active":
    case "completed":
    case "complete":
      return "success";
    case "pending":
    case "draft":
      return "warning";
    case "paused":
      return "default";
    case "archived":
      return "error";
    default:
      return "default";
  }
};

export default function ReportItem({ item, index, openViewReport, editReport }) {
  function capitalizeFirstLetter(val) {
    return String(val)?.charAt(0)?.toUpperCase() + String(val)?.slice(1);
  }

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB").replace(/\//g, "-");
  };

  return (
    <TableRow
      hover
      sx={{
        "& td": {
          py: 1.5,
          px: 2.5,
          borderBottom: "1px solid #F3F4F6",
          fontSize: "14px",
        },
        "&:hover": {
          backgroundColor: "#FAFAFA !important",
        },
        "&:nth-of-type(even)": {
          backgroundColor: "rgba(248, 250, 252, 0.5)",
        },
        cursor: "pointer",
      }}
      onClick={() => openViewReport(item)}
    >
      <TableCell
        sx={{
          color: "#1F2937",
          fontWeight: 500,
          fontSize: "15px",
        }}
      >
        <Tooltip title={item.title} arrow placement="top">
          <span
            style={{
              display: "inline-block",
              maxWidth: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {item.title}
          </span>
        </Tooltip>
      </TableCell>

      <TableCell sx={{ textAlign: "center", color: "#4b5563" }}>
        {item.inf_cnt}
      </TableCell>

      <TableCell sx={{ textAlign: "center", color: "#64748B" }}>
        {formatDate(item.start_date)} - {formatDate(item.end_date)}
      </TableCell>

      <TableCell sx={{ textAlign: "center", color: "#64748B" }}>
        0
      </TableCell>

      <TableCell sx={{ textAlign: "center" }}>
        {item.status ? (
          <Chip
            label={capitalizeFirstLetter(item.status)}
            size="small"
            color={getStatusColor(item.status)}
            variant="outlined"
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              textTransform: "capitalize",
            }}
          />
        ) : "-"}
      </TableCell>

      <TableCell sx={{ textAlign: "center" }}>
        <div className="flex items-center justify-center gap-1">
          <Tooltip title="View" arrow>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                openViewReport(item);
              }}
              sx={{ color: "#6b7280", "&:hover": { backgroundColor: "#e5e7eb" } }}
            >
              <FileText size={18} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit" arrow>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                editReport(item);
              }}
              sx={{ color: "#6b7280", "&:hover": { backgroundColor: "#e5e7eb" } }}
            >
              <Edit size={18} />
            </IconButton>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
}
